const LunarLander = () => {
    return (
        <div>
            <p>
                One day I decided, I should remake the old Atari game Lunar Lander.
                <br />
                This was my third larger game project with plain Java, so I knew what I was doing
                to some extent, but I still faced many challenges. A few of those were setting up all the game
                mechanics, terrain collision checking and sound effects.
                <br />
                I used <a target="_blank" href="https://en.wikipedia.org/wiki/Perlin_noise">Perlin Noise</a> to create the values (shape) of the terrain.
            </p>
        </div>
    )
}

export default LunarLander;